
<template lang="pug">
  Slide(:enable-scroll-indication="true")
    .content-container
      h1 Simple Ways To Protect Your Data

      p.instructions We’ve spent a lot of time covering various ways cybercriminals attempt to scam people and how you can avoid those scams. Here’s a quick list of additional personal security strategies. 
      p.instructions Select each icon to learn more.

      ModalStack
        .modal-container
          Modal(
            title="Keep Devices and Software Updated"
            :image="require('@/assets/images/1400_1_UpdatedModalButton.png')"
            alt=""
            :image-completed="require('@/assets/images/000_CheckPink.png')"
            alt-completed="Completed"
            :completion-by-inner-component="false"
            size="custom"
            aria-describedby="modal1"
          )
            template(v-slot:modalContainer)
              .modal-box#modal1
                h2 Keep Devices and Software Updated
                .modal-content-container
                  p Manufacturers and developers often issue updates to patch crucial security vulnerabilities. Outdated devices and software provide cybercriminals an opportunity to exploit those vulnerabilities. Enable automatic updates so you never miss an important security fix.
          
          Modal(
            title="Use Proper Disposal "
            :image="require('@/assets/images/1400_2_DisposalModalButton.png')"
            alt=""
            :image-completed="require('@/assets/images/000_CheckBlue.png')"
            alt-completed="Completed"
            :completion-by-inner-component="false"
            size="custom"
            aria-describedby="modal2"
          )
            template(v-slot:modalContainer)
              .modal-box#modal2
                h2 Use Proper Disposal 
                .modal-content-container
                  p Scammers aren’t opposed to digging through dumpsters, hoping to find anything valuable. It’s always best to shred or destroy highly sensitive documents, like banking and tax statements. When selling or recycling smart devices, be sure to reset them to factory defaults and erase all personal info. 
          
          Modal(
            title="Install Antivirus Software"
            :image="require('@/assets/images/1400_3_AntivirusModalButton.png')"
            alt=""
            :image-completed="require('@/assets/images/000_CheckGreen.png')"
            alt-completed="Completed"
            :completion-by-inner-component="false"
            size="custom"
            aria-describedby="modal3"
          )
            template(v-slot:modalContainer)
              .modal-box#modal3
                h2 Install Antivirus Software
                .modal-content-container
                  p Antivirus software can help identify, quarantine, and remove harmful computer programs. There are many options for antivirus software on the market, some of which are free while others cost a subscription fee. Do some research and find a solution that works best for you. 
          
          Modal(
            title="Remain Skeptical "
            :image="require('@/assets/images/1400_4_SkepticalModalButton.png')"
            alt=""
            :image-completed="require('@/assets/images/000_CheckPurple.png')"
            alt-completed="Completed"
            :completion-by-inner-component="false"
            size="custom"
            aria-describedby="modal4"
          )
            template(v-slot:modalContainer)
              .modal-box#modal4
                h2 Remain Skeptical 
                .modal-content-container
                  p Always treat any requests for money or confidential information with a healthy level of doubt. If you do receive a notification about unusual activity on an account, or anything similar, go directly to the legitimate website or call the number associated with the account. 

    
</template>

<script>
export default {
  methods: {
    attachModalCSS() {
      document.querySelector("body").classList.add("text-modals");
    },
    detachModalCSS() {
      document.querySelector("body").classList.remove("text-modals");
    },
  },
  mounted() {
    this.attachModalCSS();
  },
  destroyed() {
    this.detachModalCSS();
  },
};
</script>

<style lang="scss">
@import "@/assets/css/_modals";
</style>

<style scoped lang="scss">
@import "@/assets/css/styles";

/* page styling */

.slide-wrapper {
  padding: 40px !important;
  background-image: url('../assets/backgrounds/BG_Desktop_Blue.png')
}
.content-container {
  min-height: 100%;
  background-color: $light-blue;
  padding: 20px;
  box-shadow: 5px 5px 3px #00000033;
  h1 {
    @include fs-section-header;
    text-align: center;
  }
  .instructions {
    @include fs-instructions();
  }

}
.ModalStack {
  .modal-container {
    height: 100%;
    max-width: 600px;
    display: flex;
    flex-wrap: wrap;
    column-gap: 20px;
    row-gap: 20px;
    justify-content: center;
    margin: 0 auto;
    .modal {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      background-color: white;
      width: 270px;
      height: 240px;
      padding: 30px 5px 5px;
      border-radius: 10px;
      box-shadow: 5px 5px 3px #00000033;
      ::v-deep .modal-controller {
        img {
          width: auto;
          height: 100%;
          max-height: 100px;
        }
        .h4 {
          color: black;
          margin-bottom: 20px;
          font-size: 1.5rem;
        }
      }
    }
  }
}

</style>
